module.exports = __webpack_public_path__ + "static/media/LearnCreatorStepGenerate.2e5c5a04.jpg";